var __templateData = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (components, continueBtnText, doneText, game, hasNarration, hasPrompt, i18n, prompt, submitUp, titleClass, undefined) {
if ( game && game.timer && game.timer.limit > 0 && !game.timer.isDisabled)
{
buf.push("<div class=\"full-screen\"><div class=\"game-stepper text-lg text-bold\"></div><div class=\"game-progress\"><div class=\"game-progress-bar\"></div></div></div>");
}
buf.push("<div class=\"content-fill\"><div class=\"content-md-fill content-sm-ver text-center content-fit\"><div class=\"row content-md-ver\"><div class=\"col-sm-12 col-md-10 col-md-offset-1 col-lg-12 col-lg-offset-0\"><h1" + (jade.cls(['statement','fade-in',titleClass], [null,null,true])) + ">");
// iterate components
;(function(){
  var $$obj = components;
  if ('number' == typeof $$obj.length) {

    for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
      var component = $$obj[i];

if ( component.hidden)
{
buf.push("<span" + (jade.attr("data-word", component.word.replace(/[\s\.\,]/g, ""), true, false)) + " data-guess=\"\" class=\"word-hidden\">");
// iterate component.word
;(function(){
  var $$obj = component.word;
  if ('number' == typeof $$obj.length) {

    for (var j = 0, $$l = $$obj.length; j < $$l; j++) {
      var letter = $$obj[j];

if ( letter.match(/[\s\.\,]/g))
{
buf.push(jade.escape(null == (jade_interp = letter) ? "" : jade_interp));
}
else
{
buf.push("<span" + (jade.attr("data-letter", letter.toLowerCase(), true, false)) + " class=\"blank hidden-letter\"><span class=\"letter-inner\">" + (jade.escape(null == (jade_interp = letter) ? "" : jade_interp)) + "</span></span>");
}
    }

  } else {
    var $$l = 0;
    for (var j in $$obj) {
      $$l++;      var letter = $$obj[j];

if ( letter.match(/[\s\.\,]/g))
{
buf.push(jade.escape(null == (jade_interp = letter) ? "" : jade_interp));
}
else
{
buf.push("<span" + (jade.attr("data-letter", letter.toLowerCase(), true, false)) + " class=\"blank hidden-letter\"><span class=\"letter-inner\">" + (jade.escape(null == (jade_interp = letter) ? "" : jade_interp)) + "</span></span>");
}
    }

  }
}).call(this);

buf.push("</span>");
}
else
{
buf.push("<span" + (jade.cls(['word',component.klass], [null,true])) + ">" + (null == (jade_interp = component.word) ? "" : jade_interp) + "</span>");
}
buf.push(jade.escape(null == (jade_interp = " ") ? "" : jade_interp));
    }

  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;      var component = $$obj[i];

if ( component.hidden)
{
buf.push("<span" + (jade.attr("data-word", component.word.replace(/[\s\.\,]/g, ""), true, false)) + " data-guess=\"\" class=\"word-hidden\">");
// iterate component.word
;(function(){
  var $$obj = component.word;
  if ('number' == typeof $$obj.length) {

    for (var j = 0, $$l = $$obj.length; j < $$l; j++) {
      var letter = $$obj[j];

if ( letter.match(/[\s\.\,]/g))
{
buf.push(jade.escape(null == (jade_interp = letter) ? "" : jade_interp));
}
else
{
buf.push("<span" + (jade.attr("data-letter", letter.toLowerCase(), true, false)) + " class=\"blank hidden-letter\"><span class=\"letter-inner\">" + (jade.escape(null == (jade_interp = letter) ? "" : jade_interp)) + "</span></span>");
}
    }

  } else {
    var $$l = 0;
    for (var j in $$obj) {
      $$l++;      var letter = $$obj[j];

if ( letter.match(/[\s\.\,]/g))
{
buf.push(jade.escape(null == (jade_interp = letter) ? "" : jade_interp));
}
else
{
buf.push("<span" + (jade.attr("data-letter", letter.toLowerCase(), true, false)) + " class=\"blank hidden-letter\"><span class=\"letter-inner\">" + (jade.escape(null == (jade_interp = letter) ? "" : jade_interp)) + "</span></span>");
}
    }

  }
}).call(this);

buf.push("</span>");
}
else
{
buf.push("<span" + (jade.cls(['word',component.klass], [null,true])) + ">" + (null == (jade_interp = component.word) ? "" : jade_interp) + "</span>");
}
buf.push(jade.escape(null == (jade_interp = " ") ? "" : jade_interp));
    }

  }
}).call(this);

buf.push("</h1></div></div></div><div class=\"word-letters block-xl\"></div></div><div" + (jade.cls(['slide-footer','block-v-lg',submitUp ? "slide-footer--up slide-down" : "slide-up"], [null,null,true])) + ">");
if ( hasPrompt)
{
buf.push("<div class=\"slide-footer-touched\"><div class=\"btn btn-muted btn-done text-ellipsis\">" + (null == (jade_interp = doneText) ? "" : jade_interp) + "</div></div>");
if ( typeof prompt === "string")
{
buf.push("<div class=\"slide-footer-prompt text-uppercase text-bold\"><div class=\"slide-footer-prompt-content content-ver\">" + (null == (jade_interp = prompt) ? "" : jade_interp) + "</div></div>");
}
}
else
{
buf.push("<div class=\"slide-footer-prompt\"><div class=\"btn btn-muted btn-done text-ellipsis content-ver\">" + (null == (jade_interp = continueBtnText || i18n("buttons.continue")) ? "" : jade_interp) + "</div></div>");
}
if ( hasNarration)
{
buf.push("<div class=\"slide-footer-narration\"><div class=\"narration-progress btn btn-muted\"><div class=\"narration-progress-bar\"></div><div class=\"wave-ellipse\"><span class=\"bullet delay-1 block-inline\">&bullet;</span><span class=\"bullet delay-2 block-inline\">&bullet;</span><span class=\"bullet delay-3 block-inline\">&bullet;</span></div></div></div>");
}
buf.push("</div>");}.call(this,"components" in locals_for_with?locals_for_with.components:typeof components!=="undefined"?components:undefined,"continueBtnText" in locals_for_with?locals_for_with.continueBtnText:typeof continueBtnText!=="undefined"?continueBtnText:undefined,"doneText" in locals_for_with?locals_for_with.doneText:typeof doneText!=="undefined"?doneText:undefined,"game" in locals_for_with?locals_for_with.game:typeof game!=="undefined"?game:undefined,"hasNarration" in locals_for_with?locals_for_with.hasNarration:typeof hasNarration!=="undefined"?hasNarration:undefined,"hasPrompt" in locals_for_with?locals_for_with.hasPrompt:typeof hasPrompt!=="undefined"?hasPrompt:undefined,"i18n" in locals_for_with?locals_for_with.i18n:typeof i18n!=="undefined"?i18n:undefined,"prompt" in locals_for_with?locals_for_with.prompt:typeof prompt!=="undefined"?prompt:undefined,"submitUp" in locals_for_with?locals_for_with.submitUp:typeof submitUp!=="undefined"?submitUp:undefined,"titleClass" in locals_for_with?locals_for_with.titleClass:typeof titleClass!=="undefined"?titleClass:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
};
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}